import { trackRecommendation } from '../../../../../../util/trackingHelper';

const LOCATION_EDIT_REGISTRY_PAGE = 'edit_website_registry_page';
export const SECTION_START_REGISTRY_HERO = 'start_registry_hero_section';

export const trackEditRegistryClick = trackingPayload => {
  trackRecommendation('Clicked', {
    ...trackingPayload,
    location: LOCATION_EDIT_REGISTRY_PAGE,
  });
};



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/RegistryContainer/util/tracking.js